var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable: no-unbound-method
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie";
import { catchError } from "rxjs/operators";
import { ConfigureService } from "../../../../../configure/configure.service";
import { AbstractService } from "../../../../../shared/abstract.service";
import { GenericService } from "../../../../../shared/generic.service";
var PaymentFormService = /** @class */ (function (_super) {
    __extends(PaymentFormService, _super);
    function PaymentFormService(http, config, genericService, cookieService) {
        var _this = _super.call(this, cookieService) || this;
        _this.http = http;
        _this.config = config;
        _this.genericService = genericService;
        _this.cookieService = cookieService;
        return _this;
    }
    PaymentFormService.prototype.createBooking = function (body) {
        return this.http
            .post(this.config.params.apiClientUri + "/v2/bookings", body, this.addAuthHeaders())
            .pipe(catchError(this.genericService.handleErrorCollection));
    };
    PaymentFormService.prototype.createBookingAsGuest = function (body) {
        return this.http
            .post(this.config.params.apiClientUri + "/v2/bookings", body)
            .pipe(catchError(this.genericService.handleErrorCollection));
    };
    PaymentFormService.prototype.getPromoCodeForSlot = function (code, slotId, user, guestEmail) {
        return this.http
            .get(this.config.params.apiClientUri + "/promo-codes/" + code + "/slots/" + slotId + (guestEmail ? "?email=" + guestEmail : ""), !!user ? this.addAuthHeaders() : undefined)
            .pipe(catchError(this.genericService.handleErrorCollection));
    };
    return PaymentFormService;
}(AbstractService));
export { PaymentFormService };
